/* eslint-disable max-len */
export const SearchFilter = "/szukaj";
export const Search = { url: "/api/search/%7Baction%7D", type: undefined as { action: string | number; } };
